import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { PoolID } from '~src/settings/bridge-settings/sections/types/PoolID';
import { FieldArray } from '~src/settings/FormikWrapperForStubbing';

import { DataConnectPoolDomainsSectionHeaders } from '../dataConnectNetworkAllowlist/DataConnectPoolDomainsSectionHeaders';
import { DataConnectPoolDomainsTableRow } from '../dataConnectNetworkAllowlist/DataConnectPoolDomainsTableRow';
import { Domain } from '../types/Domain';
import { UserDefinedPoolModel } from '../types/PoolModel';

export type MultiPoolTableEntryDomainsProps = Readonly<{
  poolId: PoolID;
  poolName: string;
  domains: Domain[];
  siteId: string;
  userDefinedPools: Record<string, UserDefinedPoolModel>;
  bridgeDomains: Record<string, Domain>;
  refreshPoolsAndClusters: () => void;
}>;
export const POOL_NODE_FIELD = 'settings.siteAdminBridgeSettings.poolNodeSettings.nodes';

export function DataConnectMultiPoolTableEntryDomains(props: MultiPoolTableEntryDomainsProps) {
  return (
    <table className={multiPoolDoaminRowTableStyle}>
      { props.domains.length !==0 ? <DataConnectPoolDomainsSectionHeaders />:<></>}
      <tbody>
        <FieldArray
          name={POOL_NODE_FIELD}
          render={() => (
            props.domains.length === 0?
            <tr>
              <td colSpan={3} style={{paddingLeft: 0}}>
                <div className={'tb-data-grid-cell-text-data-connect tb-data-grid-DataConnect-center'}>
                  { Messages.dataConnectSiteSettingsPoolDomainDefaultRowDescription()}
                </div>
              </td>
            </tr>
          :
            props.domains.map((domain: Domain, index: number) => (
              <tr key={index}>
                <DataConnectPoolDomainsTableRow
                  domain={domain}
                  index={index}
                  poolTestId={'pool-'+props.poolId+'-'}
                  poolId={props.poolId}
                  poolName={props.poolName}
                  userDefinedPools={props.userDefinedPools}
                  bridgeDomains={props.bridgeDomains}
                  refreshPoolsAndClusters={props.refreshPoolsAndClusters}
                />
              </tr>))
          )}
        />
      </tbody>
    </table>
  );
}

export const multiPoolDoaminRowTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default',
  paddingTop: 16,
  paddingBottom: 24,
  width: '100%'
});